import * as React from 'react'
import classNames from 'classnames'
import * as styles from './style.module.scss'

interface IBannerProps {
  body: string
  link: string
  cta: string
  bannerType: 'download-rider' | 'onboard'
  localStorageKey: string
}

const isClosed = (localStorageKey: string) => {
  const lastClosedStr = localStorage.getItem(localStorageKey)
  if (!lastClosedStr) {
    return false
  }
  const lastClosed = parseInt(lastClosedStr, 10)
  return lastClosed && Date.now() - lastClosed < 60 * 20 * 1000 // 20 minutes
}

export const Banner: React.FunctionComponent<IBannerProps> = ({
  bannerType,
  body,
  link,
  cta,
  localStorageKey
}) => {
  const [slideUp, toggle] = React.useState(false)
  const closed = isClosed(localStorageKey)

  const onClose = () => {
    toggle(true)
    localStorage.setItem(localStorageKey, Date.now().toString())
  }

  const logoClasses = classNames(
    bannerType === 'onboard' ? styles.onboardLogo : styles.riderAppLogo,
    styles.appLogo
  )

  // TODO: align with the standard method for GA tagging in carpool (data-ga-action)
  const gtmClass = bannerType === 'onboard' ? 'gtm-onboard-banner' : 'gtm-download-app-banner'

  return (
    <div
      className={classNames(
        gtmClass,
        styles.downloadAppBanner,
        slideUp && styles.slideUp,
        closed && styles.bannerClosed
      )}
    >
      <div
        onClick={onClose}
        className={classNames('w-icon-x', `${gtmClass}--close`, styles.closeButton)}
      />
      <div className={logoClasses} />
      <div className={styles.logoAndBody}>
        <div className={styles.carpoolWhiteLogo} />
        <span>{body}</span>
      </div>
      <a className={classNames(styles.bannerCtaButton, `${gtmClass}--click`)} href={link}>
        {cta}
      </a>
    </div>
  )
}
